export const expertServiceTypes = [
  { label: "Capacitación", value: "WORKSHOP" },
  { label: "Mentoría", value: "MENTORSHIP" },
  { label: "Servicio", value: "PRODUCT" }
];
